import { render, staticRenderFns } from "./ConfirmStatus.vue?vue&type=template&id=55677a52"
import script from "./ConfirmStatus.vue?vue&type=script&lang=js"
export * from "./ConfirmStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports